<template>
  <header>
    <b-navbar class="bg-white nav1">
      <b-navbar-brand class="text-h1 ml-2 text-dark" to="/">{{ShopName}}</b-navbar-brand>
      <b-navbar-toggle target="topbar-nav-collapse"></b-navbar-toggle>
      <b-collapse id="topbar-nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto" right>
          <b-nav-form class="mr-3">
            <b-input-group size="sm">
              <b-form-input v-model="keyword" placeholder="搜尋商品名稱" @keydown.enter.prevent="onClickSearch"></b-form-input>
              <template v-slot:append>
                <b-button @click.prevent="onClickSearch" class="search btn-pur-outline">
                  <font-awesome-icon icon="search" />
                </b-button>
              </template>
            </b-input-group>
          </b-nav-form>
          <b-nav-item to="/cart" class="mr-1 i-color" id="cart-icon">
            <font-awesome-icon icon="shopping-cart" /><span class="items-in-cart-count">{{CartItemCount}}</span>
          </b-nav-item>
          <b-tooltip variant="success" :show="showCartAdd" target="cart-icon" triggers="">商品已成功添加</b-tooltip>
          <b-tooltip variant="success" :show="showCartChange" target="cart-icon" triggers="">購物車已更新</b-tooltip>
          <b-nav-item-dropdown v-if="UserLogined" right class="mr-2 i-color">
            <template v-slot:button-content>
              <font-awesome-icon icon="user" />
            </template>
            <b-dropdown-item to="/personal">個人資料</b-dropdown-item>
            <b-dropdown-item to="/deliver">個人訂單</b-dropdown-item>
            <b-dropdown-item @click="onClickLogout" >登出</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-else to="/login" class="mr-2 i-color">
            <font-awesome-icon icon="user" />
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-navbar toggleable="sm" class="bg-white nav2 navbar-white">
      <b-navbar-toggle target="classify-nav-collapse"></b-navbar-toggle>
      <b-collapse id="classify-nav-collapse" is-nav>
        <b-navbar-nav align="center" class="w-100">
          <b-nav-item v-for="classify in classifies" :key="classify.id" :to="classify.link" class="px-2 mb-0 h6">
            {{ classify.name }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch, faShoppingCart, faUser } from '@fortawesome/free-solid-svg-icons'
import { State } from '../library/EventBus.js'

library.add(faSearch, faShoppingCart, faUser)

export default {
  data () {
    return {
      keyword: '',
      showCartAdd: false,
      showCartChange: false
    }
  },
  computed: {
    UserLogined () {
      return Boolean(State.user.id)
    },
    CartItemCount () {
      return State.cartCounter
    },
    Cart () {
      return State.cart
    },
    ShopName () {
      return State.ShopName
    },
    classifies () {
      return State.topClassify
    }
  },
  methods: {
    async onClickLogout () {
      await this.$api.logout()
      this.$bus.$emit('update:user')
      this.$bus.$emit('update:cart')
      this.$router.push('/').catch(err => console.log(err))
    },
    onClickSearch () {
      if (!this.keyword) return
      this.$router.push({
        path: '/search',
        query: { keyword: this.keyword }
      }).then(() => {
        this.keyword = ''
      }).catch(err => console.log(err))
    }
  },
  watch: {
    CartItemCount (val, old) {
      if (val > old) {
        this.showCartAdd = true
        setTimeout(() => {
          this.showCartAdd = false
        }, 3000)
      }
    },
    Cart (val, old) {
      if (val !== old) {
        this.showCartChange = true
        setTimeout(() => {
          this.showCartChange = false
        }, 3000)
      }
    }
  }
}
</script>

<style scoped>
  .text-h1 {
    font-size: 1.7rem !important;
	font-weight: bold;
	letter-spacing: .05em;
	color: #2d2256!important;
  }
  header {
    position: sticky;
    top: 0;
    z-index: 999;
  }
  header nav.nav1 {
    z-index: 1;
	height: 70px;
	padding: .3rem 1rem;
	border-bottom: 1px solid #d1d2f9;
	/*box-shadow: inset 0 -1px 0 0 #d1d2f9;*/
  }
  header nav.nav2 {
	padding: 0;
	box-shadow: inset 0 -1px 0 0 #d1d2f9;
  }
  .nav2 .nav-item a {
    padding: .9rem .1rem;
	margin: 0 1.5rem;
	font-size: .97rem;
	letter-spacing: .05rem;
	color: rgba(38, 23, 100, 0.6);
  }
  .nav2 .nav-item:hover a, .nav2 .navbar-nav .nav-item a.active {
    transition: .3s;
    box-shadow: inset 0 -3px 0 0 #7b8cde;
	color: #7b8cde;
  }
  .items-in-cart-count {
    display: inline-block;
    background-color: #7b8cde;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 2px solid white;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    height: 20px;
    line-height: 16px;
    margin-left: -6px;
    text-align: center;
    width: 20px;
    visibility: visible;
  }
  .input-group input {
    border-radius: 50px;
	border-right: none;
  }
  form-control:focus {
    border-color: #93a3f0;
	box-shadow: 0 0 0 0.2rem rgba(123, 140, 222, 0.5);
  }
  .search {
    border-left: none;
    border-top-right-radius: 50px!important;
    border-bottom-right-radius: 50px!important;
    border-color: #ced4da;
  }
  .search:hover {
	color: #5364b5;
	background: none;
	border-color: #ced4da;
  }
  .navbar-light .navbar-nav .i-color .nav-link, .navbar-light .navbar-nav .i-color a svg, .dropdown-toggle::after {
    color: rgba(0,0,0,.4);
  }
  .navbar-light .navbar-nav .i-color .nav-link:hover, .navbar-light .navbar-nav .i-color a svg:hover,
  .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
    color: #7b8cde;
  }
  @media (max-width: 768px) {
    header nav.nav1 {height: 110px; display: block; background-color: #5364b5!important;}
	.navbar-light .navbar-toggler {border: none;}
	.nav1 .ml-auto { margin: 0 auto;}
	.text-h1 {color: #fff!important;}
	.navbar-light .navbar-nav .i-color .nav-link, .navbar-light .navbar-nav .i-color a svg, .dropdown-toggle::after {color: #fff;}
	.items-in-cart-count { border: 2px solid #5364b5;}
  }
</style>